export default __webpack_public_path__ + "static/media/cs_icon_03.b11aa59b.png";